module.exports = __webpack_public_path__ + "static/media/loader.cc800807.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 242
// module chunks = 0